export function username(s){

}

export function name(s){

}

export function mobile(s){

}

export function validEmail(rule, value, callback){
    if (!value) {
        return callback();
    }else{
        if(value.trim().length > 50){
            return callback(new Error("邮箱账号不能超过50个字符"));
        }
        if(!/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)){
            return callback(new Error("请填写正确的邮箱账号"));
        }else{
            return callback();
        }
    }
}

export function stringTrim(rule, value, callback){
    if(value.trim().length){
        callback();
    }else{
        callback(new Error("请勿输入空格!"));
    }
}

//用户列表密码强弱
export const PASSOWRD_REG_WEEK = /^[0-9]{6,16}$|^[A-Z]{6,16}$|^[a-z]{6,16}$|^[\W_!@#$%^&*`~()-+=]{6,16}$/;
export const PASSOWRD_REG_MIDDLE = /^(?!\d+$)(?![a-zA-Z]+$)[\da-zA-Z]{8,10}$|^(?!\d+$)(?![\x00-\xff]+$)[\d\x00-\xff]{8,10}$|^(?!a-zA-Z+$)(?![\x00-\xff]+$)[a-zA-Z\x00-\xff]{6,10}$/;
export const PASSOWRD_REG_POWER = /^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])(?=.*\d)[^]{6,16}$|^(?=.*[a-zA-Z])(?=.*[\W_!@#$%^&*`~()-+=])[^]{6,16}$|^(?=.*\d)(?=.*[\W_!@#$%^&*`~()-+=])[^]{10,16}$|^(?=.*[a-zA-Z])(?=.*\d)[^]{6,16}$/;


